import React from 'react'
import { NavLink } from 'react-router-dom';

const Hero = () => {
  return (
    <section className='flex md:flex-row flex-col lg:py-24 py-16 gap-10'>

      {/* ── Left: copy ── */}
      <div className='flex-1 flex justify-center items-start flex-col'>

        {/* Headline — desktop */}
        <h1 className="hidden md:block font-poppins font-[900] md:text-[54px] text-[36px] text-black md:leading-[68px] leading-[46px] mb-5">
          Reach Customers.<br />
          Sell Products.<br />
          <span className='text-[#0071BC]'>Grow Faster.</span>
        </h1>

        {/* Headline — mobile */}
        <h1 className="md:hidden font-poppins font-[900] text-[34px] text-black leading-[44px] mb-4">
          Reach Customers.<br />
          Sell Products.<br />
          <span className='text-[#0071BC]'>Grow Faster.</span>
        </h1>

        <p className="font-poppins font-normal text-gray-500 md:text-[15px] text-[13px] md:leading-[26px] leading-[22px] max-w-[530px]">
          Send targeted <strong className="text-gray-700">bulk SMS campaigns</strong> to thousands of customers,
          list and sell on our <strong className="text-gray-700">product marketplace</strong>,
          and create smart links for instant WhatsApp connections — all from one dashboard.
        </p>

        {/* Feature pills */}
        <div className='flex flex-wrap gap-2 mt-5'>
          <span className='flex items-center gap-1.5 bg-green-50 text-green-700 text-[12px] font-semibold px-3 py-1.5 rounded-full border border-green-100'>
            📨 Bulk SMS
          </span>
          <span className='flex items-center gap-1.5 bg-purple-50 text-purple-700 text-[12px] font-semibold px-3 py-1.5 rounded-full border border-purple-100'>
            🛍️ Marketplace
          </span>
          <span className='flex items-center gap-1.5 bg-blue-50 text-[#0071BC] text-[12px] font-semibold px-3 py-1.5 rounded-full border border-blue-100'>
            🔗 Smart Links
          </span>
        </div>

        {/* CTA buttons */}
        <div className='flex flex-row mt-8 gap-3'>
          <NavLink to='/login'>
            <button className="text-white bg-[#0071BC] hover:bg-[#005fa0] transition-colors font-medium rounded-[45px] text-[14px] md:px-[30px] md:py-3 px-5 py-2.5">
              Get Started Free
            </button>
          </NavLink>
          <NavLink to='/product-demo'>
            <button className="text-[#0071BC] bg-[#DBF2FF] font-medium rounded-[45px] text-[14px] md:px-[30px] md:py-3 px-4 py-2.5 inline-flex items-center gap-2">
              Watch Demo
              <svg width="20" height="20" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5 2.5C10.5222 2.5 8.58879 3.08649 6.9443 4.1853C5.29981 5.28412 4.01809 6.8459 3.26121 8.67317C2.50433 10.5004 2.3063 12.5111 2.69215 14.4509C3.078 16.3907 4.03041 18.1725 5.42894 19.5711C6.82746 20.9696 8.60929 21.922 10.5491 22.3079C12.4889 22.6937 14.4996 22.4957 16.3268 21.7388C18.1541 20.9819 19.7159 19.7002 20.8147 18.0557C21.9135 16.4112 22.5 14.4778 22.5 12.5C22.5 11.1868 22.2413 9.88642 21.7388 8.67317C21.2363 7.45991 20.4997 6.35752 19.5711 5.42893C18.6425 4.50035 17.5401 3.76375 16.3268 3.2612C15.1136 2.75866 13.8132 2.5 12.5 2.5ZM10.5 17V8L16.5 12.5L10.5 17Z" fill="#0071BC" />
              </svg>
            </button>
          </NavLink>
        </div>

        {/* Flutterwave */}
        <div className='flex items-center gap-2 mt-6'>
          <p className="font-poppins font-bold text-gray-400 text-[13px]">Payment powered by</p>
          <img src="/images/Flutterwave_Logo.png" className='w-[130px]' alt="Flutterwave" />
        </div>
      </div>

      {/* ── Right: illustration ── */}
      <div className='flex-1 flex justify-center items-center lg:mt-0 mt-10'>
        <div className='relative w-full max-w-[580px] h-[580px]'>

          {/* Background blob */}
          <div className='absolute inset-0 bg-gradient-to-br from-blue-50 via-purple-50 to-green-50 rounded-3xl'></div>

          {/* ─ Phone mockup — center ─ */}
          <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[200px] bg-gray-900 rounded-[40px] shadow-2xl overflow-hidden border-[5px] border-gray-800 z-10'>
            <div className='bg-gray-900 h-6 flex items-center justify-center'>
              <div className='w-16 h-2 bg-gray-700 rounded-full'></div>
            </div>
            <div className='bg-white pb-4'>
              <div className='bg-[#0071BC] text-white text-center text-[11px] py-2 font-semibold tracking-widest'>
                GUPTA SMS
              </div>
              <div className='px-3 pt-3 flex flex-col gap-2.5'>
                <div className='bg-[#0071BC] text-white text-[11px] rounded-xl rounded-tl-none px-3 py-2 max-w-[90%] leading-snug'>
                  Hi! Your order is confirmed 🎉
                </div>
                <div className='bg-[#0071BC] text-white text-[11px] rounded-xl rounded-tl-none px-3 py-2 max-w-[95%] leading-snug'>
                  Flash sale: 30% off all items today only!
                </div>
                <div className='bg-gray-100 text-gray-500 text-[10px] rounded-xl rounded-tl-none px-3 py-2 max-w-[72%]'>
                  Reply STOP to opt out
                </div>
              </div>
            </div>
          </div>

          {/* ─ Campaign card — top right ─ */}
          <div className='absolute top-8 right-4 bg-white shadow-xl rounded-2xl p-4 w-[195px]'>
            <div className='flex items-center gap-2.5 mb-3'>
              <div className='w-8 h-8 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0'>
                <svg className='w-4 h-4 text-green-600' fill='none' viewBox='0 0 24 24' stroke='currentColor' strokeWidth={3}>
                  <path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
                </svg>
              </div>
              <span className='text-[13px] font-bold text-gray-700'>Campaign Sent!</span>
            </div>
            <p className='text-[11px] text-gray-400 mb-2'>1,247 recipients</p>
            <div className='flex gap-2'>
              <div className='flex-1 bg-green-50 rounded-xl text-center py-2'>
                <div className='text-[13px] font-bold text-green-700'>98%</div>
                <div className='text-[10px] text-green-500'>Delivered</div>
              </div>
              <div className='flex-1 bg-blue-50 rounded-xl text-center py-2'>
                <div className='text-[13px] font-bold text-[#0071BC]'>34%</div>
                <div className='text-[10px] text-blue-400'>Opened</div>
              </div>
            </div>
          </div>

          {/* ─ Marketplace card — bottom right ─ */}
          <div className='absolute bottom-8 right-4 bg-white shadow-xl rounded-2xl p-4 w-[195px]'>
            <div className='bg-purple-50 rounded-xl h-20 flex items-center justify-center mb-3'>
              <span className='text-4xl'>👟</span>
            </div>
            <div className='text-[13px] font-bold text-gray-800'>Arike Shoes</div>
            <div className='text-[11px] text-gray-400 mb-2'>₦15,000</div>
            <div className='flex items-center justify-between'>
              <span className='text-[10px] bg-purple-100 text-purple-700 font-semibold px-2.5 py-1 rounded-full'>Marketplace</span>
              <span className='text-[11px] font-bold text-green-600'>+3 orders</span>
            </div>
          </div>

          {/* ─ New order — top left ─ */}
          <div className='absolute top-8 left-4 bg-white shadow-xl rounded-2xl px-4 py-3 flex items-center gap-3 w-[165px]'>
            <span className='text-2xl'>🛒</span>
            <div>
              <p className='text-[12px] font-bold text-gray-700'>New Order!</p>
              <p className='text-[11px] text-purple-600 font-semibold'>₦12,500 earned</p>
            </div>
          </div>

          {/* ─ Smart Links — bottom left ─ */}
          <div className='absolute bottom-8 left-4 bg-white shadow-xl rounded-2xl p-4 w-[165px]'>
            <div className='flex items-center gap-2 mb-2'>
              <div className='w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center text-base'>🔗</div>
              <span className='text-[13px] font-bold text-gray-700'>Smart Links</span>
            </div>
            <div className='text-[11px] text-gray-400 mb-1'>gupta.link/store</div>
            <div className='text-[14px] text-[#0071BC] font-bold'>342 clicks</div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Hero;
